import { useEffect, useRef } from 'react';

const YMAPS_CLASS_NAMES = ['ymaps', 'copyright__link'] as const;
const TERMS_URL = 'https://yandex.ru/legal/maps_termsofuse/ru' as const;

/** Хук, который добавляет ссылку на условия использования сервиса Яндекс Карты **/
export const useYandexTermsLinks = () => {
  const processedLinks = useRef<WeakSet<HTMLAnchorElement>>(new WeakSet());

  const processLink = (link: HTMLAnchorElement) => {
    if (processedLinks.current.has(link)) return;

    const isEmptyHref = !link.href || link.href === '' || link.getAttribute('href') === '';
    const isYmapsLink = YMAPS_CLASS_NAMES.every(item => link.className.includes(item));

    if (isEmptyHref && isYmapsLink) {
      link.href = TERMS_URL;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      processedLinks.current.add(link);
    }
  };

  const processMutations = (mutations: MutationRecord[]) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          const links = node.querySelectorAll<HTMLAnchorElement>(`[class*="${YMAPS_CLASS_NAMES[1]}"]`);
          links.forEach(processLink);
        }
      });
    });
  };

  useEffect(() => {
    const observer = new MutationObserver(processMutations);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);
};
